import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function departureTimeFiltered({ value, totalTrips }) {
    const property = {
        hours: value,
        num_trips: totalTrips,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: 'time_depart',
        property,
    });

    amplitude.track('search_filtered', {
        filter_type: 'departure_time',
        results_count_before: totalTrips,
        updated_to: value,
    });
}

function arrivalTimeFiltered({ value, totalTrips }) {
    const property = {
        hours: value,
        num_trips: totalTrips,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: 'time_arrive',
        property,
    });

    amplitude.track('search_filtered', {
        filter_type: 'arrival_time',
        results_count_before: totalTrips,
        updated_to: value,
    });
}

export default {
    arrivalTimeFiltered,
    departureTimeFiltered,
};
